import React, { useMemo, useState } from 'react';
import PlacementsTable from '../../components/PlacementsTable';
import { fmtDate, useFetch } from '../../hooks';
import { Alert, Card, Chip, Segmented, Skeleton } from '../../ui/basics';
import { Calendar } from '../../ui/charts';
import { yearChoices } from './Weekly';

export default function Daily({ org, lead }) {
  const years = useMemo(yearChoices, []);
  const [selected, setSelected] = useState([years[0]]);
  const [kind, setKind] = useState('started');
  const [day, setDay] = useState('');
  const { data, loading, error } = useFetch(selected.length ? 'reports/daily/' : null,
    { organization: org, lead, years: [...selected].sort().join(',') });

  const points = useMemo(() => (data ? data.data
    .map((d) => ({ day: d.date, value: kind === 'started' ? d.candidate_joined_date : d.candidate_end_date }))
    .filter((d) => d.value > 0) : []), [data, kind]);
  const sorted = [...selected].sort();
  const total = points.reduce((sum, p) => sum + p.value, 0);

  const toggle = (year) => {
    setDay('');
    setSelected((prev) => (prev.includes(year) ? prev.filter((y) => y !== year) : [...prev, year]));
  };
  const filters = kind === 'started' ? { joined_from: day, joined_to: day } : { ended_from: day, ended_to: day };

  return (
    <div className="stack">
      <Card title={`Candidates ${kind} per day`} subtitle={`${total.toLocaleString()} candidates ${kind} in the selected years · click a day for the list`}
        actions={<div className="row">
          <div className="row" style={{ gap: 6 }}>{years.map((y) => <Chip key={y} on={selected.includes(y)} onClick={() => toggle(y)}>{y}</Chip>)}</div>
          <Segmented value={kind} onChange={(k) => { setKind(k); setDay(''); }} options={[{ value: 'started', label: 'Started' }, { value: 'ended', label: 'Ended' }]} />
        </div>}>
        {error && <Alert>{error}</Alert>}
        {!selected.length ? <p className="muted">Pick at least one year.</p>
          : loading ? <Skeleton h={220} />
            : <Calendar data={points} from={`${sorted[0]}-01-01`} to={`${sorted[sorted.length - 1]}-12-31`}
              height={190 * (Number(sorted[sorted.length - 1]) - Number(sorted[0]) + 1)}
              onClick={(d) => d.value !== undefined && setDay(d.day)} />}
      </Card>
      {day && (
        <Card flush title={`Candidates ${kind} on ${fmtDate(day)}`}>
          <PlacementsTable key={`${kind}-${day}`} fixed={{ organization: org, lead }} initialFilters={filters} initialSize={10} />
        </Card>
      )}
    </div>
  );
}
